
import Vidle from 'v-idle';
import { Component, Vue, Watch, } from 'vue-property-decorator';
import { handleOverlay, } from '~/apps/account/account';
import AccountNav from '~/apps/account/components/account-nav/account-nav.vue';
import FeedbackBox from '~/components/feedback-box/feedback-box.vue';
import Spinner from '~/components/spinner/spinner.vue';
import UnauthedNav from '~/components/unauthed-nav/unauthed-nav.vue';
import 'core-js/es/string/pad-start';
import { Store, } from './store';
import { checkUserDetails, } from './store/user-details-service';

Vue.use(Vidle);

function applyExternalLinksToFooter() {
	const footer = document.querySelector('footer.footer');
	const footerLinks = footer?.querySelectorAll('a') || [];
	for (const link of footerLinks) {
		if (!link.target) {
			link.target = '_blank';
			link.rel = 'noopener noreferrer';
			link.dataset.voyext = true.toString();
		}
	}
}

function removeExternalLinksToFooter() {
	const footer = document.querySelector('footer.footer');
	const footerLinks = footer?.querySelectorAll('a') || [];
	for (const link of footerLinks) {
		if (Boolean(link.dataset.voyext) === true) {
			link.target = '';
			link.rel = '';
		}
	}
}

@Component({
	components: {
		AccountNav,
		Alert: () => import('~/components/alert/alert.vue'),
		FeedbackBox,
		Overlay: () => import('~/components/overlay/overlay.vue'),
		Spinner,
		UnauthedNav,
		Vidle,
	},
})
export default class AccountApp extends Vue {

	get showSpinner() {
		return Store.state.showSpinner;
	}

	get showOverlay() {
		return Store.state.isOverlayVisible;
	}

	get currentUser() {
		return Store.state.userDetails;
	}

	get activeAlert() {
		return Store.state.alertModule.activeAlert;
	}

	get registrationSuccessShowHeader() {
		return Store.state.register.registrationSuccessShowHeader;
	}

	get moveOutDate() {
		if (Store.state.contractPropertyDetails.state === 'completed' && Store.state.contractPropertyDetails.result.moveOutDate) {
			return Store.state.contractPropertyDetails.result.moveOutDate;
		}
		return null;
	}

	get meterDetail() {
		return Store.getters.meterList;
	}

	get paymentMethod() {
		if (Store.state.contractAccountDetails.state === 'completed' && Store.state.contractAccountDetails.result.paymentMethod) {
			return Store.state.contractAccountDetails.result.paymentMethod;
		}
		return null;
	}

	get meterReading() {
		return Store.state.meterRead.currentMeterReading;
	}

	get isTimerOverlay() {
		return Store.state.isTimerOverlay;
	}

	get isDisplayNewFeature() {
		return Store.state.isDisplayNewFeature;
	}

	sessionPoll: number | null = null;

	beforeUpdate() {
		if (localStorage.getItem('bpNumberFromLoginResponse')) {
			checkUserDetails();
		}
	}

	mounted() {
		const tick = () => {
			this.$authService.checkSession().finally(() => {
				this.sessionPoll = window.setTimeout(tick, 60 * 1000);
			});
		};
		tick();
	}

	destroyed() {
		if (this.sessionPoll) {
			clearInterval(this.sessionPoll);
		}
	}

	get currentMessage() {
		const currentMessage = Store.getters.availableMessage;
		if (currentMessage && this.$route.name !== 'Login') {
			Store.commit.makeMessageAsRead();
		}

		return currentMessage;
	}

	get currentMessageComponentWrapper() {
		const currentMessage = this.currentMessage?.body;
		if (currentMessage === null || typeof currentMessage !== 'string') {
			return 'div';
		}

		if (currentMessage.trimStart().startsWith('<')) {
			return 'div';
		}

		return 'p';
	}

	get selectedContractAccount() {
		return Store.state.selectContractAccount;
	}

	get getCustomerPropertyDetailList() {
		if (Store.state.switchAccountDetails.state === 'completed') {
			return Store.state.switchAccountDetails.result;
		}
		return [];
	}

	get overlayMessage() {
		return Store.state.overlayMessage;
	}

	get overlayComponent() {
		return Store.state.navigateTo;
	}

	@Watch('$store.getters.isAuthenticated', { immediate: true, })
	onIsAuthenticatedChange(isAuthenticated: boolean) {
		try {
			if (isAuthenticated) {
				applyExternalLinksToFooter();
			} else {
				removeExternalLinksToFooter();
			}
		} catch {
			// We do not care this fails
		}
	}

	@Watch('$route')
	onRouteChange() {
		this.$nextTick(() => {
			const focusTarget = document.querySelector('header') as HTMLElement;
			focusTarget.setAttribute('tabindex', '-1');
			focusTarget.focus();
			focusTarget.removeAttribute('tabindex');
		});
	}

	logo = Store.getters.getGlobalConfigValue('SouthernWaterLogo');
	logoWidth = Store.getters.getGlobalConfigValue('SouthernWaterLogoWidth');
	logoHeight = Store.getters.getGlobalConfigValue('SouthernWaterLogoHeight');
	get logoDetails() {
		return Store.getters.getGlobalConfigValue('SouthernWaterLogoDetails');
	}

	closeAlert() {
		Store.commit.dismissActiveAlert();
	}

	closeOverlay() {
		Store.commit.meterRead.setMeterReading(0);
		Store.commit.moveOut.setMeterReading(0);
		Store.commit.closeOverlay();
	}

	overlaySubmit() {
		Store.commit.closeOverlay();
		void this.$router.push(Store.state.navigateTo);
	}

	onidle() {
		void this.$authService.logout({ type: 'Warning', title: 'You’ve been logged out', body: 'Your session timed out due to inactivity. Please sign in again to continue.', });
	}

	onremind() {
		handleOverlay();
	}
}
